// SignInWithGoogle.tsx
import React from "react";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useNavigate, useLocation } from "react-router-dom";

import { auth } from "../../../firebaseConfig";

import "./google-sign-in.css";

const SignInWithGoogle: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // ──────────────────────────────────────────────────────────
  // 1.  Pull redirect target (new flow) or shortID (legacy)
  // ──────────────────────────────────────────────────────────
  const searchParams = new URLSearchParams(location.search);
  const redirect = searchParams.get("redirect");
  const shortID = searchParams.get("shortID");

  // ──────────────────────────────────────────────────────────
  // 2.  Sign-in popup + unified navigation
  // ──────────────────────────────────────────────────────────
  const handleSignInWithGoogle = async (): Promise<void> => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);

      // Primary: new redirect-based flow
      if (redirect) {
        navigate(redirect, { replace: true });
        return;
      }
      // Fallback: old shortID-based links
      if (shortID) {
        navigate(`/card/${shortID}`, { replace: true });
        return;
      }
      // Default home if nothing else
      navigate("/", { replace: true });
    } catch (err: unknown) {
      const error = err as { code?: string; message?: string };
      console.error("Google sign-in error:", error.code, error.message);
      // TODO: surface the error to the user if you wish
    }
  };

  return (
    <button
      type="button"
      className="login-with-google-btn"
      onClick={handleSignInWithGoogle}
    >
      Sign in with Google
    </button>
  );
};

export default SignInWithGoogle;
